import { render, staticRenderFns } from "./DailyQuestion.vue?vue&type=template&id=1a87231e&scoped=true"
import script from "./DailyQuestion.vue?vue&type=script&lang=js"
export * from "./DailyQuestion.vue?vue&type=script&lang=js"
import style0 from "./DailyQuestion.vue?vue&type=style&index=0&id=1a87231e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87231e",
  null
  
)

export default component.exports